const WsColors = {
  TheBlues950: '#337ab7',
  TheBlues900: '#03045E',
  TheBlues800: '#023E8A',
  TheBlues750: ' #0C66E4',
  TheBlues700: '#0077B6',
  TheBlues600: '#0096C7',
  TheBlues500: '#00B4D8',
  TheBlues400: '#48CAE4',
  TheBlues300: '#90E0EF',
  TheBlues200: '#ADE8F4',
  TheBlues100: '#CAF0F8',
  TheBlues50: '#F2FBFD',
  TheBlues75: '#E5F9FB',
  TheBlues25: '#FAFAFC',
  TertiaryShades900: '#484D6D',
  TertiaryShades800: '#616893',
  TertiaryShades700: '#6F75A0',
  TertiaryShades600: '#7E84AA',
  TertiaryShades500: '#A0A4C0',
  TertiaryShades400: '#A9ADC6',
  TertiaryShades300: '#CED0DF',
  TertiaryShades200: '#DDDEE8',
  TertiaryShades100: '#EAEAF1',
  TertiaryShades50: '#F6F6F9',
  Green700: '#00BBA4',
  Green600: '#00918B',
  Green500: '#02D8CE',
  Green400: '#12EDE3',
  Green300: '#84F1EC',
  Green200: '#BBF2EF',
  Green100: '#E0F5F4',
  Red500: '#FF2E49',
  Red400: '#F85D72',
  Red300: '#FB93A0',
  Red200: '#FDC9D0',
  Red100: '#FED8DD',
  Yellow700: '#9F580A',
  Yellow600: '#B98500',
  Yellow500: '#FFC42E',
  Yellow400: '#F8D372',
  Yellow300: '#F6E1AC',
  Yellow200: '#F6EBD0',
  Yellow100: '#F9F4E7',
  Neutral500: ' #77949A',
  Neutral300: ' #B3BCBE',
  BorderGrey: '#EAEAF1',
  GreyText: '#11151C',
  GreyText2: '#484D6D',
  Red: '#FF0000',
  GreyBlack: '#A0A4C0',
  White: '#FFFFFF',
  GenericRichBlack: '#11151C',
  YellowCompliment: '#AE7D00',
  None: '',
  BackGround: '#f5f5f5',
  IconBackGround: '#2c006e',
  TheBlue75: '#EFFCFD',
  BackGroundGreen: '#00BBA4',
  BackGroundYellow: '#E9B327',
  ForestGreen: '#108229',
  Pink: '#FF8DA1',
  GreyShade: '#f9f9f',
  LightGray: '#F0F2F3',
  Gray88: '#E0E0E0',
  YellowBg: '#FDF6B2',
  YellowBorder: '#E3A008',
  BackGroundRed: ' #FED8DD',
  DarkRed: '#C00000',
  BackGroundGrey: '#E5E7EB',
  DefaultColor: '#000000',
  DefaultHeaderCellColor: '#f1f3f5',
  LinkOutline: ' #0891B2',
  LinkActive: ' #60A5FA',
  LinkVisited: ' #C026D3',
  ToolbarColor: '#ccc',
};

export default WsColors;
